import { render, staticRenderFns } from "./datasource-form-tab2.vue?vue&type=template&id=004704a7&scoped=true&"
import script from "./datasource-form-tab2.vue?vue&type=script&lang=ts&"
export * from "./datasource-form-tab2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004704a7",
  null
  
)

export default component.exports